import { render, staticRenderFns } from "./LocationComponentsContainer.vue?vue&type=template&id=24e3ec36&scoped=true&lang=pug&"
import script from "./LocationComponentsContainer.vue?vue&type=script&lang=ts&"
export * from "./LocationComponentsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./LocationComponentsContainer.vue?vue&type=style&index=0&id=24e3ec36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e3ec36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e3ec36')) {
      api.createRecord('24e3ec36', component.options)
    } else {
      api.reload('24e3ec36', component.options)
    }
    module.hot.accept("./LocationComponentsContainer.vue?vue&type=template&id=24e3ec36&scoped=true&lang=pug&", function () {
      api.rerender('24e3ec36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/location-components/LocationComponentsContainer.vue"
export default component.exports